module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "rnote",
      "title": "Note on Terms"
    }
  }, [_c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('p', {
    staticClass: "h2f"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xiii",
      "title": "xiii"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253037756_Contents#note"
    }
  }, [_vm._v("Note on Terms")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("Y")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGOSLAVIA WAS COMPOSED")]), _vm._v(" of many ethnic groups. In the postwar era, the largest groups were Serbs, Croats, Bosnian Muslims, Macedonians, Slovenians, and Montenegrins. When discussing immigrants from Yugoslavia in general terms and when my sources do not make clear the ethnicity of the immigrants they describe, I use the term "), _c('i', [_vm._v("Yugoslavs")]), _vm._v(". German archival and print sources tend to refer to labor migrants from Yugoslavia simply as “Yugoslavs.” But sources almost always refer to postwar political émigrés and refugees during the 1990s specifically as ethnic Croats, Serbs, Bosnians, or members of other ethnic groups. Whenever it is relevant and possible, I provide the ethnic identity of the immigrants under discussion. I have preferred “Roma” rather than the derogatory “Gypsy,” which is used herein only when it appears in sources or to highlight the language of historical actors. Unless otherwise noted, all translations from German are my own."), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xiv",
      "title": "xiv"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fea1dd9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253037756_Terms.vue
// module id = 75
// module chunks = 0